export default {
  onboarding: {
    title: 'Esta é uma SAFE Tag!',
    description: 'Você pode vincular sua SAFE Tag e começar a ser protegido por SOSAFE',
  },
  linkSafetag: 'Link SAFE Tag',
  disclaimerSosafe: 'Baixe a versão mais recente do SOSAFE para vincular sua SAFE Tag',
};
